import request from 'axios';

const getTrails = async (query) => {
  return await request.get("/json/trails.json", {query: query});
};

const getTrail = async (id) => {
  return await request.get(`/json/trails/${id}.json`)
};


export {getTrails, getTrail};
